import { render, staticRenderFns } from "./VedioMax.vue?vue&type=template&id=2ddd2fb1&scoped=true"
import script from "./VedioMax.vue?vue&type=script&lang=js"
export * from "./VedioMax.vue?vue&type=script&lang=js"
import style0 from "./VedioMax.vue?vue&type=style&index=0&id=2ddd2fb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd2fb1",
  null
  
)

export default component.exports